// web component for video player controls
// Usage: <video-container></video-container>
class VideoContainer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const video = this.querySelector("video");
    this.addVideoPlayPauseToggle(video);
    this.addSoundMuteUnmuteToggle(video);
  }

  addVideoPlayPauseToggle(video) {
    const playPauseBtn = this.querySelector(".video-play-pause-control");
    const playIcon = playPauseBtn?.querySelector(".play-button");
    const pauseIcon = playPauseBtn?.querySelector(".pause-button");

    if (video && playPauseBtn) {
      // Initial setup based on the video playing state
      video.addEventListener("play", () => {
        playIcon.classList.add("display-none"); // Hide play icon
        pauseIcon.classList.remove("display-none"); // Show pause icon
      });

      video.addEventListener("pause", () => {
        playIcon.classList.remove("display-none"); // Show play icon
        pauseIcon.classList.add("display-none"); // Hide pause icon
      });

      // Set initial state based on whether the video is autoplaying or paused
      if (video.paused) {
        playIcon?.classList.remove("display-none"); // Show play icon
        pauseIcon?.classList.add("display-none"); // Hide pause icon
      } else {
        playIcon?.classList.add("display-none"); // Hide play icon
        pauseIcon?.classList.remove("display-none"); // Show pause icon
      }

      // Add event listener to toggle play/pause on button click
      playPauseBtn.addEventListener("click", () => {
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
      });
    }
  }

  addSoundMuteUnmuteToggle(video) {
    const muteUnmuteBtn = this.querySelector(".video-sound-control");
    const muteIcon = muteUnmuteBtn?.querySelector(".mute-button");
    const soundIcon = muteUnmuteBtn?.querySelector(".sound-button");

    if (video && muteUnmuteBtn) {
      // Add event listener to toggle mute/unmute on button click
      muteUnmuteBtn.addEventListener("click", () => {
        if (video.muted) {
          video.muted = false;
          muteIcon?.classList.add("display-none"); // Show mute icon
          soundIcon?.classList.remove("display-none"); // Hide sound icon
        } else {
          video.muted = true;
          muteIcon?.classList.remove("display-none"); // Hide mute icon
          soundIcon?.classList.add("display-none"); // Show sound icon
        }
      });
    }
  }
}
customElements.define('video-container', VideoContainer);
